/**
 * Home dashboard fetchers for native ISO 27002, FCA RM 2024, and UC IS-3 projects.
 * Reuses calculateStandardSpecificAverages / calculateControlTitleAverages + standardsCalculations
 * (same path as CRF-S dashboard ISO / FCA / UC cases) after loading quality data for a fixed year.
 */
jQuery(document).ready(function () {
    'use strict';
    if (!window.WebAssessmentCharts || typeof WebAssessmentCharts.registerHomeDashboardFetcher !== 'function') {
        return;
    }

    var crossStdCache = {};
    var crossStdState = { areAveragesCalculated: false, lastCalculatedStandard: null };
    var ctrlTitleCache = {};
    var ctrlTitleState = { areAveragesByControlTitlesCalculated: false };

    function resetCrossStandardCaches() {
        crossStdCache = {};
        crossStdState = { areAveragesCalculated: false, lastCalculatedStandard: null };
        ctrlTitleCache = {};
        ctrlTitleState = { areAveragesByControlTitlesCalculated: false };
    }

    function homeChartsBucket() {
        WebAssessmentCharts.__homeIsoFcaUcCharts = WebAssessmentCharts.__homeIsoFcaUcCharts || {};
        return WebAssessmentCharts.__homeIsoFcaUcCharts;
    }

    async function ensureQualityData(year) {
        var y = String(year || '2025');
        if (WebAssessmentCharts.qualityData && String(WebAssessmentCharts.assessmentYear) === y) {
            return WebAssessmentCharts.qualityData;
        }
        if (typeof WebAssessmentCharts.fetchQualityData !== 'function') {
            throw new Error('fetchQualityData is not available');
        }
        var data = await WebAssessmentCharts.fetchQualityData(y);
        WebAssessmentCharts.qualityData = data;
        WebAssessmentCharts.assessmentYear = y;
        return data;
    }

    async function prepareProcessedItems(projectSlug) {
        var projectData = await WebAssessmentCharts.fetchProjectChartData(projectSlug);
        if (!projectData || !Array.isArray(projectData)) {
            throw new Error('Project data missing or invalid');
        }
        WebAssessmentCharts.processedItems = processUniqueItemsCIS(projectData);
    }

    async function runIso2013(projectSlug) {
        resetCrossStandardCaches();
        await prepareProcessedItems(projectSlug);
        await ensureQualityData('2025');
        var averages = calculateStandardSpecificAverages(
            'ISO2013', WebAssessmentCharts, crossStdCache, crossStdState);
        var fn = WebAssessmentCharts.ISO270022013 || window.ISO270022013;
        if (typeof fn !== 'function') {
            throw new Error('ISO270022013 is not loaded');
        }
        fn(averages, homeChartsBucket());
    }

    async function runIso2022(projectSlug) {
        resetCrossStandardCaches();
        await prepareProcessedItems(projectSlug);
        await ensureQualityData('2025');
        var averages = calculateStandardSpecificAverages(
            'ISO2022', WebAssessmentCharts, crossStdCache, crossStdState);
        var fn = WebAssessmentCharts.ISO270022022 || window.ISO270022022;
        if (typeof fn !== 'function') {
            throw new Error('ISO270022022 is not loaded');
        }
        fn(averages, homeChartsBucket());
    }

    async function runUcis3(projectSlug) {
        resetCrossStandardCaches();
        await prepareProcessedItems(projectSlug);
        await ensureQualityData('2025');
        var averages = calculateStandardSpecificAverages(
            'UCIS3', WebAssessmentCharts, crossStdCache, crossStdState);
        var fn = WebAssessmentCharts.UCIS3 || window.UCIS3;
        if (typeof fn !== 'function') {
            throw new Error('UCIS3 is not loaded');
        }
        fn(averages, homeChartsBucket());
    }

    async function runFcarm2024(projectSlug) {
        resetCrossStandardCaches();
        await prepareProcessedItems(projectSlug);
        await ensureQualityData('2025');
        var av = calculateControlTitleAverages(WebAssessmentCharts, ctrlTitleCache, ctrlTitleState);
        var fn = WebAssessmentCharts.FCARM2024 || window.FCARM2024;
        if (typeof fn !== 'function') {
            throw new Error('FCARM2024 is not loaded');
        }
        fn(av, homeChartsBucket());
    }

    WebAssessmentCharts.registerHomeDashboardFetcher('iso-27002-2013', runIso2013);
    WebAssessmentCharts.registerHomeDashboardFetcher('iso-27002-2022', runIso2022);
    WebAssessmentCharts.registerHomeDashboardFetcher('uc-policy-is-3', runUcis3);
    WebAssessmentCharts.registerHomeDashboardFetcher('fca-rm-2024', runFcarm2024);
});
